import ServiceConfigs from '../../service/config';

interface SetAuthCookieOptions {
  token: string;
  isManualOrder?: boolean;
}

interface SetAuthCookieResponse {
  success: boolean;
  error?: string;
}

/**
 * Sets authentication cookie server-side to bypass Safari's 7-day script-writeable storage cap.
 *
 * @param options - Configuration options for setting the cookie
 * @param options.token - The authentication token to store
 * @param options.isManualOrder - Whether this is a manual order (affects SameSite policy)
 * @returns Promise that resolves to success status
 */
export const setAuthCookieServerSide = async (options: SetAuthCookieOptions): Promise<SetAuthCookieResponse> => {
  try {
    const { token, isManualOrder = false } = options;

    const response = await fetch('/api/auth/set-cookie', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        token,
        isManualOrder,
      }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
    }

    // Update ServiceConfigs so existing code continues to work
    ServiceConfigs.setUserToken(token);

    return { success: true };
  } catch (error) {
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Unknown error occurred',
    };
  }
};
